import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFocus = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M1.775,8.213l0,-4.476c0,-1.084 0.879,-1.963 1.963,-1.963l4.476,0",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.56px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.855,1.775l4.476,0c1.084,0 1.963,0.879 1.963,1.963l0,4.476",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.56px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.294,15.96l0,4.371c0,1.084 -0.879,1.963 -1.963,1.963l-4.476,0",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.56px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.213,22.294l-4.476,0c-1.084,0 -1.963,-0.879 -1.963,-1.963l0,-4.371",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.56px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.408,11.921c0,2.87 2.33,5.199 5.199,5.199c2.87,0 5.199,-2.33 5.199,-5.199c0,-2.87 -2.33,-5.199 -5.199,-5.199c-2.87,0 -5.199,2.33 -5.199,5.199Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.56px"
				}
			})
		]
	})
});
export default SvgFocus;
